"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    extractAddress: function() {
        return extractAddress;
    },
    stringifyAddress: function() {
        return stringifyAddress;
    }
});
const _object = require("../utils/object");
function extractAddress(address) {
    if (!address) return undefined;
    const [lines, city, statePostalCode, ...rest] = address.split(',');
    const [line1, line2] = lines.split('\n');
    const postalCode = extractPostalCode(statePostalCode);
    const state = postalCode ? statePostalCode.replace(postalCode, '') : statePostalCode;
    const out = (0, _object.deleteUndefined)({
        addressLine1: line1.trim(),
        addressLine2: line2 == null ? void 0 : line2.trim(),
        city: city == null ? void 0 : city.trim(),
        state: state == null ? void 0 : state.trim(),
        postalCode: postalCode == null ? void 0 : postalCode.trim(),
        country: rest.length ? rest.join(', ').trim() : undefined
    });
    return out;
}
function extractPostalCode(input) {
    const matches = input.match(/((?:\d{5}(?:\d{4})?|[A-Za-z][0-9][A-Za-z](?: [0-9][A-Za-z][0-9])?))/);
    return (matches == null ? void 0 : matches.length) ? matches[0] : undefined;
}
function stringifyAddress(address) {
    if (!address) return '';
    if (typeof address === 'string') return address;
    const { addressLine1, addressLine2, city, state, postalCode, country } = address;
    const lines = [
        addressLine1,
        addressLine2
    ].filter((x)=>x);
    const statePostalCode = postalCode ? `${state} ${postalCode}` : state;
    const rest = [
        country
    ].filter((x)=>x);
    const out = [
        lines.join('\n'),
        city,
        statePostalCode,
        ...rest
    ].join(', ');
    return out;
}

//# sourceMappingURL=address.js.map